import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="purchase-calculator"
export default class extends Controller {
  static values = { 
    smsCost: Number, 
    currentBalance: Number, 
    currency: String 
  }
  
  static targets = [ 
    "purchaseAmount", 
    "smsCredits", 
    "newBalance", 
    "amountRadio", 
    "customAmount" 
  ]
  
  static optionalTargets = [
    "purchaseAmount", 
    "smsCredits", 
    "newBalance"
  ]

  connect() {
    console.log("Purchase calculator connected")
    console.log("Currency:", this.currencyValue)
    console.log("Current balance:", this.currentBalanceValue)
    console.log("SMS cost:", this.smsCostValue)
    this.updateSummary()
  }

  updateSummary(event) {
    let amount = 0
    
    // Get amount from radio button or custom input
    if (event && event.target.type === "radio") {
      amount = parseFloat(event.target.dataset.amount) || parseFloat(event.target.value) || 0
      // Clear custom amount when radio is selected
      const customAmountInput = document.querySelector('input[name="custom_amount"]')
      if (customAmountInput) {
        customAmountInput.value = ""
      }
    } else if (event && event.target.type === "number") {
      amount = parseFloat(event.target.value) || 0
      // Clear radio selections when custom amount is entered
      const radioButtons = document.querySelectorAll('input[name="amount"]')
      radioButtons.forEach(radio => radio.checked = false)
    } else {
      // Initial load - check for any selected values
      const selectedRadio = document.querySelector('input[name="amount"]:checked')
      if (selectedRadio) {
        amount = parseFloat(selectedRadio.value) || 0
      } else {
        const customAmountInput = document.querySelector('input[name="custom_amount"]')
        if (customAmountInput && customAmountInput.value) {
          amount = parseFloat(customAmountInput.value) || 0
        }
      }
    }

    console.log("Amount selected:", amount)
    console.log("Has purchase amount target:", this.hasPurchaseAmountTarget)
    console.log("Has SMS credits target:", this.hasSmsCreditsTarget)
    console.log("Has new balance target:", this.hasNewBalanceTarget)
    
    // Update purchase amount
    if (this.hasPurchaseAmountTarget) {
      const formattedAmount = this.formatCurrency(amount)
      console.log("Updating purchase amount to:", formattedAmount)
      this.purchaseAmountTarget.textContent = formattedAmount
    } else {
      console.error("Purchase amount target not found!")
    }
    
    // Calculate and update SMS credits
    const smsCredits = amount > 0 ? Math.floor(amount / this.smsCostValue) : 0
    if (this.hasSmsCreditsTarget) {
      const formattedCredits = `≈ ${smsCredits.toLocaleString()} messages`
      console.log("Updating SMS credits to:", formattedCredits)
      this.smsCreditsTarget.textContent = formattedCredits
    } else {
      console.error("SMS credits target not found!")
    }
    
    // Calculate and update new balance
    const newBalance = this.currentBalanceValue + amount
    if (this.hasNewBalanceTarget) {
      const formattedBalance = this.formatCurrency(newBalance)
      console.log("Updating new balance to:", formattedBalance)
      this.newBalanceTarget.textContent = formattedBalance
    } else {
      console.error("New balance target not found!")
    }
  }

  // Legacy method for backward compatibility
  calculateCost() {
    this.updateSummary()
  }

  formatCurrency(amount) {
    try {
      // Use simple formatting since UGX/KES/TZS aren't standard Intl currency codes
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: this.currencyValue === 'UGX' || this.currencyValue === 'TZS' ? 0 : 2,
        maximumFractionDigits: this.currencyValue === 'UGX' || this.currencyValue === 'TZS' ? 0 : 2
      })
      
      return `${this.currencyValue} ${formatter.format(amount)}`
    } catch (error) {
      console.error("Error formatting currency:", error)
      return `${this.currencyValue} ${amount}`
    }
  }
}
